import { useEffect, useState } from 'react';

/**
 * Live zusammensetzen oder den vorgerechneten Film abspielen (7.71).
 *
 * Sascha, 9. September: „Vielleicht müssen wir es vorrendern.“ Wie das Thema
 * und die Leinwand gehört die Wahl dem Gerät und nicht dem Konto: sie ist
 * eine Frage der Leistung. Voreinstellung ist „Ebenen“ -- der Film ist ein
 * Angebot, sobald einer zum Schnitt passt.
 */
export type Filmwahl = 'ebenen' | 'film';

const SCHLUESSEL = 'schnitt.film';

export function geleseneFilmwahl(): Filmwahl {
  try {
    if (localStorage.getItem(SCHLUESSEL) === 'film') return 'film';
  } catch {
    /* Ein Browser ohne Speicher ist kein Grund, nicht zu arbeiten. */
  }
  return 'ebenen';
}

const horcher = new Set<(wahl: Filmwahl) => void>();

export function setFilmwahl(wahl: Filmwahl): void {
  try {
    localStorage.setItem(SCHLUESSEL, wahl);
  } catch {
    /* siehe oben */
  }
  for (const h of horcher) h(wahl);
}

export function useFilmwahl(): Filmwahl {
  const [wahl, setzen] = useState<Filmwahl>(geleseneFilmwahl);
  useEffect(() => {
    horcher.add(setzen);
    return () => {
      horcher.delete(setzen);
    };
  }, []);
  return wahl;
}

/** Läuft gerade wirklich ein Film? Für den Befund vom Gerät (7.71). */
let laeuft = false;
export function setFilmLaeuft(an: boolean): void {
  laeuft = an;
}
export function filmLaeuft(): boolean {
  return laeuft;
}
